import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {
    PRICING_DASHBOARD_PAGES,
    BACK_BUTTON, Add_BUTTON, Edit_BUTTON, DAY, PRODUCT_ASIN_PRICING_TABLE_CELLS
} from "../constants";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import './PricingDashboardForm.css';
import withShipment from "../../../withShipment";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import {
    addRelatedProduct,
    fetchPricingListings,
    getBuyBoxPrices,
    getSalesRank,
    editRelatedProduct,
    getRelatedProducts,
    updateRelatedProducts,
    clearSalesRankAndBuyBoxPrice,
    fetchShortcodeAsinPrices,
} from '../../../redux/actions/settings';
import {
    buyBoxPricesSelector,
    mainSalesRankSelector,
    subSalesRankSelector,
    relatedProductsMainSalesRankSelector,
    relatedProductsSelector,
    relatedProductBuyBoxPricesSelector,
    shortcodeAsinPricesSelector,
} from '../../../redux/selectors/settings';
import AddCircleIcon from "@material-ui/icons/AddCircle";

import AddRelatedProductPopper from "./AddRelatedProductPopper";
import {IconButton, Tooltip} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import EditRelatedProducts from "./EditRelatedProducts";
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import { ViewList } from '@material-ui/icons';
import TablePage from '../../global/Table/TablePage';
import { Layout } from '../../global/Table/TablePageHelpers/LayoutObject';
import { TableCell} from '@mui/material';

class PricingDashboardForm extends React.Component{
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.state = {
            showSubCategoryChart: false,
            responseMessage: "",
            feedbackBarOpen: false,
            showEditRelatedProducts: false,
            mainSalesRank:[],
            subSalesRank: [],
            relatedProductsMainSalesRank:[],
            originalRelatedProductsMainSalesRank: [],
            buyBoxPrices: [],
            relatedProductBuyBoxPrices: [],
            sortRelatedProductByRank: this.getcurrentAsinSetting()?.sortRelatedProductByRank?this.getcurrentAsinSetting().sortRelatedProductByRank : false,
            display90DaysData: false,
            isShortcodeAsinPricingView : false,
        };
    }

    componentDidMount() {
        const currentDate = new Date()
        const thirtyDaysBefore = new Date(currentDate)
        thirtyDaysBefore.setDate(currentDate.getDate() - 30)
        // Convert both dates to ISO strings in UTC ("YYYY-MM-DDTHH:MM:SSZ")
        const startDate = thirtyDaysBefore.toISOString().replace(/\.\d+Z$/, 'Z') // Replaces '.sssZ' with 'Z'
        const endDate = currentDate.toISOString().replace(/\.\d+Z$/, 'Z') // Replaces '.sssZ' with 'Z'
        this.props.getSalesRank(this.props.row.webstoreProductId, startDate, endDate)
        this.props.getBuyBoxPrices(this.props.row.webstoreProductId, startDate, endDate)
        this.props.getRelatedProducts(this.props.row.webstoreProductId)
        this.props.fetchShortcodeAsinPrices(this.props.row.webstoreProductId, startDate, endDate)

    }

    componentDidUpdate(prevProps) {
        if (prevProps.mainSalesRank !== this.props.mainSalesRank ||
            prevProps.subSalesRank !== this.props.subSalesRank ||
            prevProps.relatedProductsMainSalesRank !== this.props.relatedProductsMainSalesRank ||
            prevProps.buyBoxPrices !== this.props.buyBoxPrices ||
            prevProps.relatedProductBuyBoxPrices !== this.props.relatedProductBuyBoxPrices) {

            this.setState({
                mainSalesRank: this.props.mainSalesRank,
                subSalesRank: this.props.subSalesRank,
                relatedProductsMainSalesRank: this.props.relatedProductsMainSalesRank,
                originalRelatedProductsMainSalesRank: [...this.props.relatedProductsMainSalesRank],
                buyBoxPrices: this.props.buyBoxPrices,
                relatedProductBuyBoxPrices: this.props.relatedProductBuyBoxPrices
            });
        }
        if(prevProps.tableSetting !== this.props.tableSetting){
            this.setState({
                sortRelatedProductByRank: this.getcurrentAsinSetting()?.sortRelatedProductByRank?this.getcurrentAsinSetting().sortRelatedProductByRank : false,
            })
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })

    }

    toggleSubCategoryChart = () => {
        this.setState(prevState => ({
            showSubCategoryChart: !prevState.showSubCategoryChart
        }));
    }

    handleAddRelatedProduct= (relatedProduct) => {
        this.props.addRelatedProduct(relatedProduct, this.props.row.webstoreProductId)
    }

    handleEditRelatedProduct= (relatedProduct) => {
        this.props.editRelatedProduct(relatedProduct, this.props.row.webstoreProductId)
    }

    toggleEditRelatedProductsShow = () => {
        this.setState({ showEditRelatedProducts: !this.state.showEditRelatedProducts })
    }

    getcurrentAsinSetting = () => {
        const { tableSetting, row } = this.props;

        if (!tableSetting || !tableSetting.pricingDashboardChartSetting) {
            return null
        }

        const currentSetting = tableSetting.pricingDashboardChartSetting.find(
            (setting) => setting.asin === row.asin && setting.marketplace === row.marketplaces[0]
        )
        return currentSetting || null
    }

    updateSortRelatedProductByRank = (newSetting) => {
        const { tableSetting, row } = this.props;

        if (!tableSetting) {
            return;
        }

        const pricingDashboardChartSetting = tableSetting.pricingDashboardChartSetting || [];

        const settingIndex = pricingDashboardChartSetting.findIndex(
            (setting) => setting.asin === row.asin && setting.marketplace === row.marketplaces[0]
        );

        if (settingIndex !== -1) {
            pricingDashboardChartSetting[settingIndex] = newSetting;
        } else {
            pricingDashboardChartSetting.push(newSetting);
        }

        this.props.saveTableSetting({
            userId: this.props.user.userId,
            changePricingDashboardChartSetting: true,
            pricingDashboardChartSetting: pricingDashboardChartSetting
        })
    }

    getPageName = () => {
        let rightHeaderButtons = [{ icon: <MenuIcon />, handler: this.toggleEditRelatedProductsShow, disabled: false, title: "Edit Related Products" }]
        return (
            <div>
                {this.props.row.shortcode? `(${this.props.row.shortcode})` + (this.props.row.quantity ? `-${this.props.row.quantity}` : '') +(this.props.row.marketplaces ? ` ${this.props.row.marketplaces[0]}` : '') : ""}
                {rightHeaderButtons && rightHeaderButtons.map((button, index) => (
                    <Tooltip title={button.title} key={button.title + index}>
                        <IconButton aria-label={button.title} onClick={button.handler} disabled={button.disabled}>
                            {button.icon}
                        </IconButton>
                    </Tooltip>
                ))}
            </div>
        );
    }
    getMainChartOptions = () => {

        const nowMs = Date.now();
        const days = this.state.display90DaysData ? 90 : 30;
        const cutoffMs = nowMs - days * DAY;

        let buyBoxPricesData= {
            name: `Buy Box Price`,
            data: this.state.buyBoxPrices.filter(item => item.timeStamp >= cutoffMs)
                .map(item => ({
                x: item.timeStamp,
                y: parseFloat(item.buyBoxPriceAmount),
                buyBoxWinnerSellerId: item.buyBoxWinner ? item.buyBoxWinner.sellerId : null,
                secondaryBuyBoxWinnerSellerId: item.secondaryBuyBoxWinner ? item.secondaryBuyBoxWinner.sellerId : null
            })),
            yAxis: 0,
            marker: {
                enabled: null,
                radius: 3,
                lineWidth: 1,
            },
            events: {
                legendItemClick: () => {
                }
            },
            tooltip: {
                valueDecimals: 2,
                valuePrefix: '$',
                pointFormatter: function () {
                    const buyBoxPrice = `${this.y.toFixed(2)}`;
                    const buyBoxWinnerSellerId = this.options.buyBoxWinnerSellerId;
                    const secondaryBuyBoxWinnerSellerId = this.options.secondaryBuyBoxWinnerSellerId;
                    let tooltipHtml = `<b>Buy Box Price:</b> ${buyBoxPrice}`;

                    if (buyBoxWinnerSellerId) {
                        tooltipHtml += `<br><b>Buy Box Winner:</b> ${buyBoxWinnerSellerId}`;
                    }
                    if (secondaryBuyBoxWinnerSellerId) {
                        tooltipHtml += `<br><b>Second Buy Box Winner:</b> ${secondaryBuyBoxWinnerSellerId}`;
                    }

                    return tooltipHtml;
                }
            }
        }

        let mainSalesRankData = this.state.mainSalesRank.map(categoryObj => {
            const categoryName = Object.keys(categoryObj)[0];
            const allPoints = categoryObj[categoryName] || [];

            const ranks = allPoints
                .filter(p => p.timeStamp >= cutoffMs);

            const lastRank = ranks.length ? ranks[ranks.length - 1].rank : '';

            return {
                name: `Sales Rank - ${categoryName}</br>Last Rank: ${lastRank}`,
                data: ranks.map(({ timeStamp, rank }) => [timeStamp, parseInt(rank, 10)]),
                yAxis: 1,
                marker: {
                    enabled: null,
                    radius: 3,
                    lineWidth: 1
                },
                events: {
                    legendItemClick: () => {
                    }
                },
                tooltip: {
                    valueDecimals: 0,
                    valuePrefix: '',
                    pointFormatter: function () {
                        const currentSalesRank = `${this.y}`;
                        let tooltipHtml = `<b>Sales Rank:</b> ${currentSalesRank}`;

                        if(lastRank){
                            tooltipHtml += `<br><b>Last Rank:</b> ${lastRank}`;
                        }
                        return tooltipHtml;
                    }
                }
            };
        });

        let subcategoryData = {
            name:`Subcategory<br>&nbsp;<br>`, //  dummy series for showing the sub category chart
            data: [],
            marker: {
                enabled: null,
                radius: 3,
                lineWidth: 1,
            },
            events: {
                legendItemClick: () => {
                    this.toggleSubCategoryChart(); // Toggle visibility of the second chart
                return false
                }
            }
        }

        if (this.state.sortRelatedProductByRank) {
            let sortedRelatedProducts = this.state.relatedProductsMainSalesRank?.sort((a, b) => {
                const lastRankA = a.salesRank[0] && a.salesRank[0][Object.keys(a.salesRank[0])[0]];
                const lastRankB = b.salesRank[0] && b.salesRank[0][Object.keys(b.salesRank[0])[0]];

                const rankA = lastRankA && lastRankA.length > 0 ? lastRankA[lastRankA.length - 1].rank : Infinity;
                const rankB = lastRankB && lastRankB.length > 0 ? lastRankB[lastRankB.length - 1].rank : Infinity;

                return parseInt(rankA, 10) - parseInt(rankB, 10);
            });
        }
        else {
            this.state.relatedProductsMainSalesRank = [...this.state.originalRelatedProductsMainSalesRank];
        }

        let relatedProductsData = [];

        //look up buy box prices using sales rank
        let section1 = this.state.relatedProductsMainSalesRank?.forEach((categoryObj, index, array) => {
            const relatedProductAsin = categoryObj.relatedProductAsin;
            const relatedProductPName = categoryObj.relatedProductName;
            const relatedProductMainRank = categoryObj.salesRank?.[0];
            if (!relatedProductMainRank) return;
            const categoryName = Object.keys(relatedProductMainRank)[0]; // Get the category name
            const ranks = (relatedProductMainRank[categoryName] || [])
                .filter(p => p.timeStamp >= cutoffMs);

            const lastRanking = ranks && ranks.length > 0 ? ranks[ranks.length - 1].rank : '';
            const lastRank = ranks && ranks.length > 0 ? `</br>Last Rank: ${ranks[ranks.length - 1].rank}` : '';

            // Find corresponding BuyBox data
            const buyBoxObj = this.state.relatedProductBuyBoxPrices?.find(obj => obj.relatedProductAsin === relatedProductAsin);

            const salesRankName = relatedProductPName !== ''
                ? `Sales Rank - ${categoryName}</br>${relatedProductPName} (${relatedProductAsin})${lastRank}${!buyBoxObj ? '<br>&nbsp;<br>' : ''}`
                : `Sales Rank - ${categoryName}</br>(${relatedProductAsin})${lastRank}${!buyBoxObj ? '<br>&nbsp;<br>' : ''}`;

            // Sales Rank data
            relatedProductsData.push({
                name: salesRankName,
                data: ranks.map(({ timeStamp, rank }) => [timeStamp, parseInt(rank, 10)]),
                yAxis: 1,
                marker: {
                    enabled: null,
                    radius: 3,
                    lineWidth: 1,
                },
                events: {
                    legendItemClick: () => {
                    }
                },
                tooltip: {
                    valueDecimals: 0,
                    valuePrefix: '',
                    pointFormatter: function () {
                        const currentSalesRank = `${this.y}`;
                        let tooltipHtml = `<b>Sales Rank:</b> ${currentSalesRank}`;

                        if (lastRanking) {
                            tooltipHtml += `<br><b>Last Rank:</b> ${lastRanking}`;
                        }

                        return tooltipHtml;
                    }
                }
            });

            if (buyBoxObj) {
                const buyBoxName = relatedProductPName !== ''
                    ? `Buy Box Price</br>${relatedProductPName} (${relatedProductAsin})<br>&nbsp;<br>`
                    : `Buy Box Price</br>(${relatedProductAsin})<br>&nbsp;<br>`;

                relatedProductsData.push({
                    name: buyBoxName,
                    data: buyBoxObj.buyBox
                        .filter(item => item.timeStamp >= cutoffMs)
                        .map(item => ({
                            x: item.timeStamp,
                            y: parseFloat(item.buyBoxPriceAmount),
                            buyBoxWinnerSellerId: item.buyBoxWinner ? item.buyBoxWinner.sellerId : null,
                            secondaryBuyBoxWinnerSellerId: item.secondaryBuyBoxWinner ? item.secondaryBuyBoxWinner.sellerId : null
                        })),
                    yAxis: 0,
                    marker: {
                        enabled: null,
                        radius: 3,
                        lineWidth: 1,
                    },
                    events: {
                        legendItemClick: () => {}
                    },
                    tooltip: {
                        valueDecimals: 2,
                        valuePrefix: '$',
                        pointFormatter: function () {
                            const buyBoxPrice = `${this.y.toFixed(2)}`;
                            const buyBoxWinnerSellerId = this.options?.buyBoxWinnerSellerId;
                            const secondaryBuyBoxWinnerSellerId = this.options?.secondaryBuyBoxWinnerSellerId;

                            let tooltipHtml = `<b>Buy Box Price:</b> ${buyBoxPrice}`;

                            if (buyBoxWinnerSellerId) {
                                tooltipHtml += `<br><b>Buy Box Winner:</b> ${buyBoxWinnerSellerId}`;
                            }
                            if (secondaryBuyBoxWinnerSellerId) {
                                tooltipHtml += `<br><b>Second Buy Box Winner:</b> ${secondaryBuyBoxWinnerSellerId}`;
                            }

                            return tooltipHtml;
                        }
                    }
                });
            }
        });

        // Add any remaining BuyBox data that wasn't matched to SalesRank
        let section2= this.state.relatedProductBuyBoxPrices?.forEach(buyBoxObj => {
            const relatedProductAsin = buyBoxObj.relatedProductAsin;
            const relatedProductPName = buyBoxObj.relatedProductName;

            // Check if this ASIN has already been processed (i.e., has SalesRank data)
            const alreadyProcessed = this.state.relatedProductsMainSalesRank?.some(
                obj => obj.relatedProductAsin === relatedProductAsin
            );

            if (!alreadyProcessed) {
                const buyBoxName = relatedProductPName !== ''
                    ? `Buy Box Price</br>${relatedProductPName} (${relatedProductAsin})<br>&nbsp;<br>`
                    : `Buy Box Price</br>(${relatedProductAsin})<br>&nbsp;<br>`;

                relatedProductsData.push({
                    name: buyBoxName,
                    data: buyBoxObj.buyBox.filter(item => item.timeStamp >= cutoffMs).map(item => ({
                        x: item.timeStamp,
                        y: parseFloat(item.buyBoxPriceAmount),
                        buyBoxWinnerSellerId: item.buyBoxWinner ? item.buyBoxWinner.sellerId : null, // Include buyBoxWinnerSellerId
                        secondaryBuyBoxWinnerSellerId: item.secondaryBuyBoxWinner ? item.secondaryBuyBoxWinner.sellerId : null
                    })),
                    yAxis: 0,
                    marker: {
                        enabled: null,
                        radius: 3,
                        lineWidth: 1,
                    },
                    events: {
                        legendItemClick: () => {}
                    },
                    tooltip: {
                        valueDecimals: 2,
                        valuePrefix: '$',
                        pointFormatter: function () {
                            const buyBoxPrice = `${this.y.toFixed(2)}`;
                            const buyBoxWinnerSellerId = this.options.buyBoxWinnerSellerId;
                            const secondaryBuyBoxWinnerSellerId = this.options.secondaryBuyBoxWinnerSellerId;

                            let tooltipHtml = `<b>Buy Box Price:</b> ${buyBoxPrice}`;

                            if (buyBoxWinnerSellerId) {
                                tooltipHtml += `<br><b>Buy Box Winner:</b> ${buyBoxWinnerSellerId}`;
                            }
                            if (secondaryBuyBoxWinnerSellerId) {
                                tooltipHtml += `<br><b>Second Buy Box Winner:</b> ${secondaryBuyBoxWinnerSellerId}`;
                            }

                            return tooltipHtml;
                        }
                    },
                });
            }
        });

        let seriesData = [
            ...mainSalesRankData.filter(s => s.data?.length),
            buyBoxPricesData,
            subcategoryData,
            ...relatedProductsData.filter(s => s.data?.length),
        ]

        let mainChartOptions = {
            chart: {
                type: 'line',
                width: 1200,
                height: 680
            },

            title: {
                text: '',
            },

            xAxis: {
                type: "datetime"
            },
            yAxis:[
                {
                    title: {
                        text: 'Buy Box Prices'
                    },
                    labels: {
                        format: '${value}',
                    }
                },
                {
                    title: {
                        text: 'Sales Rank'
                    },
                    opposite: true,
                    reversed: true,
                }

            ],

            series:
            seriesData,
            legend: {
                title: {
                    text: this.props.row.shortcode
                        ? this.props.row.shortcode + (this.props.row.quantity ? `-${this.props.row.quantity}` : '') + (this.props.row.asin ? ` (${this.props.row.asin})` : '') + '<br/>'
                        : (this.props.row.asin ? this.props.row.asin : ""),
                    style: {
                        fontSize: '1.2em'
                    }
                },
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                itemMarginBottom: 5,
                itemStyle: {fontSize : "1.05.em"},
            },
            time: {
                useUTC: false
            },
            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    pointStart: 2010
                }
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        };

        return mainChartOptions;
    }

    getSubCategoryChartOptions = () => {
        const nowMs = Date.now();
        const days = this.state.display90DaysData ? 90 : 30;
        const cutoffMs = nowMs - days * DAY;

        let subSalesRankData = this.state.subSalesRank.map(categoryObj => {
            const categoryName = Object.keys(categoryObj)[0];
            const ranksAll = categoryObj[categoryName] || [];
            const ranks = ranksAll.filter(p => p.timeStamp >= cutoffMs);
            const lastRank = ranks.length ? ranks[ranks.length - 1].rank : '';

            return {
                name: categoryName,
                data: ranks.map(({ timeStamp, rank }) => [timeStamp, parseInt(rank, 10)]),
                marker: {
                    enabled: null,
                    radius: 3,
                    lineWidth: 1,
                },
                tooltip: {
                    valueDecimals: 0,
                    valuePrefix: '',
                    pointFormatter: function () {
                        const currentSalesRank = `${this.y}`;
                        let tooltipHtml = `<b>Sales Rank:</b> ${currentSalesRank}`;

                        if(lastRank){
                            tooltipHtml += `<br><b>Last Rank:</b> ${lastRank}`;
                        }

                        return tooltipHtml;
                    }
                }
            };
        });

        let subChartOptions = {
            chart: {
                type: 'line',
                width: 1260,
                height: 680
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime'
            },
            yAxis: {
                title: {
                    text: 'Sales Rank'
                },
                reversed: true,
            },
            series: subSalesRankData,
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                itemMarginBottom: 5,
                itemStyle: {fontSize: "1.05.em"},
                title: {
                    text: this.props.row.shortcode ? `${this.props.row.shortcode}${this.props.row.quantity ? `-${this.props.row.quantity}` : ''}<br/>` : '',
                    style: {
                        fontSize: '1.2em'
                    }
                },
            },
            time: {
                useUTC: false
            }
        };

        return subChartOptions;
    }

    hideBuyBoxPrices = () => {
        const chart = this.chartRef?.current?.chart; // Access the chart instance
        if (chart) {
            chart.series.forEach(series => {
                // exclude "Buy Box Price", which is the main buyBoxPrice
                if (series.name.includes('Buy Box Price') && series.name !== 'Buy Box Price') {
                    series.setVisible(false, false);
                }
            });
            chart.redraw();
        }
    }

    getMinTsFromState = () => {
        const series = this.state.mainSalesRank || [];
        if (!series.length) return null;
        const cat = Object.keys(series[0])[0];
        const pts = series[0][cat] || [];
        return pts.length ? pts[0].timeStamp : null;
    };


    toggleDateRange = () => {
        const willShow90 = !this.state.display90DaysData;
        if (willShow90) {
            // Only fetch if we don't already have 90 days cached
            const now = Date.now();
            const wantStart = now - 90 * DAY;
            const haveMin = this.getMinTsFromState();
            const needsFetch = !(haveMin && haveMin <= wantStart);

            if (needsFetch) {
                const startISO = new Date(wantStart).toISOString().replace(/\.\d+Z$/, 'Z');
                const endISO   = new Date(now).toISOString().replace(/\.\d+Z$/, 'Z');
                this.props.getSalesRank(this.props.row.webstoreProductId, startISO, endISO);
                this.props.getBuyBoxPrices(this.props.row.webstoreProductId, startISO, endISO);
            }
        }
        this.setState({ display90DaysData: willShow90 });
    };

    setToggleAsinView = () => {
        this.setState(
            prevState => ({
                isShortcodeAsinPricingView: !prevState.isShortcodeAsinPricingView
            })
        )
    }

    hideSalesRank = () => {
        const chart = this.chartRef?.current?.chart; // Access the chart instance
        if (chart) {
            let firstSalesRankFound = false;

            chart.series.forEach(series => {
                if (series.name.includes('Sales Rank')) {
                    if (!firstSalesRankFound) {
                        firstSalesRankFound = true;
                    } else {
                        // Hide subsequent "Sales Rank" series
                        series.setVisible(false, false);
                    }
                }
            });
            chart.redraw();
        }
    }

    handleBack = () => {
        this.props.clearSalesRankAndBuyBoxPrice()
        this.props.setCurrentPage(PRICING_DASHBOARD_PAGES.TABLE)
    }


    getTableHeaders = () => {
        let headers = []
        PRODUCT_ASIN_PRICING_TABLE_CELLS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id, "center"))
        })
        headers.push(Layout.columnHead(null,null,null))
        return headers
    }


    tableRow = (row, index) => {
      return (
        <>
          <TableCell
            className='center'
            style={{ width: '16.66%',  paddingLeft: '3px' }}
          >
            {row?.name}
          </TableCell>
          <TableCell
            className='center'
            style={{ paddingLeft: '3px' }}
          >
            {row?.pack}
          </TableCell>
          <TableCell
            className='center'
            style={{ width: '16.66%',paddingLeft: '3px'}}
          >
            {row?.asin}
          </TableCell>
          <TableCell
            className='center'
            style={{paddingLeft: '3px' }}
          >{this.formatDollar(row?.price + row?.shipping)}

          </TableCell>
          <TableCell
            className='center'
            style={{width: '16.66%', paddingLeft: '3px' }}
          >
            {row?.sales ? `${row.sales}+` : ''}
          </TableCell>
             <TableCell
            className='center'
            style={{width: '16.66%', paddingLeft: '3px' }}
          >
            {row?.reviews}
          </TableCell>
          <TableCell
            className='center'
            style={{ width: '16.66%',paddingLeft: '3px' }}
          >
            {row?.sellerName}
          </TableCell>
        </>
      )
    }

    formatDollar = (amount) => {
        if (amount === null || amount === undefined) {
            amount = 0;
        }

        const amountStr = parseFloat(amount).toFixed(2).toString();

        // Check if amountStr is NaN after parsing
        if (isNaN(amountStr)) {
            return '';
        } else {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '3px',
                    marginRight: '15px'
                }}>
                    <span style={{ flexShrink: 0, marginLeft: '16px', marginRight: '16px' }}>$</span>
                    <span style={{ marginLeft: 'auto' }}>
                    {amountStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span>
                </div>
            );
        }
    }


    render() {
        const { showSubCategoryChart } = this.state;
        return (
            <React.Fragment>
                <TopToolbar
                    pageName={this.getPageName()}
                    menuItems={[
                        {title: BACK_BUTTON, icon: <KeyboardBackspaceIcon/>, onClick: this.handleBack},
                        {title: Add_BUTTON, icon: <AddCircleIcon/>,
                            popper: <AddRelatedProductPopper
                                handleAddRelatedProduct={(relatedProduct) => this.handleAddRelatedProduct(relatedProduct)}
                            />},
                    ]}
                />
                <div className="mainChart">
                    <div className="hidebutton" style={{ display: 'flex', alignItems: 'center'}}>
                        <Tooltip title="Hide all related product buy box prices">
                            <IconButton onClick={this.hideBuyBoxPrices} style={{ cursor: 'pointer',style: {marginRight: '10px'} }}>
                                <MoneyOffIcon />
                            </IconButton>
                        </Tooltip>
                        <span>Hide all related product buy box prices</span>

                        <Tooltip title="Hide all related product sales rank">
                            <IconButton onClick={this.hideSalesRank} style={{ cursor: 'pointer' }}>
                                <FilterListOffIcon />
                            </IconButton>
                        </Tooltip>
                        <span>Hide all related product sales rank</span>

                        <Tooltip title="Change date range of data">
                            <IconButton onClick={this.toggleDateRange} style={{ cursor: 'pointer' }}>
                                <MoreTimeIcon/>
                            </IconButton>
                        </Tooltip>
                        {this.state.display90DaysData ? <span>Display 30 days of data</span> : <span>Display 90 days of data</span>}

                      <Tooltip title="View product pricing table">
                          <IconButton onClick={this.setToggleAsinView} style={{ cursor: 'pointer' }}>
                              <ViewList />
                          </IconButton>
                      </Tooltip>
                      <span>View product pricing table</span>
                    </div>
                </div>

                {this.state.isShortcodeAsinPricingView ?
                    (this.props.shortcodeAsinPrices || []).map((asinGroup, index) => (
                      <div key={asinGroup.asin} style={{ marginBottom: '20px',marginTop:'-50px' }}>
                        <TablePage
                          tableName={`shortcodeAsinPricingTable-${asinGroup.asin}`}
                          tableRows={asinGroup.top3BuyBox}
                          tableColumnHeads={this.getTableHeaders()}
                          tableRow={this.tableRow}
                        />
                      </div>
                    ))
                :
                <div>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getMainChartOptions()}
                        ref={this.chartRef}
                    />
                    <div className="subChart">
                        {showSubCategoryChart ?
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getSubCategoryChartOptions()}
                          />
                          : null}
                    </div>
                    {this.state.showEditRelatedProducts && (
                      <EditRelatedProducts
                        showEditRelatedProducts={this.state.showEditRelatedProducts}
                        relatedProducts={this.props.relatedProducts}
                        updateRelatedProducts={this.props.updateRelatedProducts}
                        row={this.props.row}
                        user={this.props.user}
                        currentAsinSetting={this.getcurrentAsinSetting()}
                        updateSortRelatedProductByRank={this.updateSortRelatedProductByRank}
                        sortRelatedProductByRank={this.state.sortRelatedProductByRank}
                      />
                    )}
                </div>
              }
          </React.Fragment>
        )
    }
}

PricingDashboardForm.defaultProps = {
    mainSalesRank: [],
    subSalesRank: [],
    relatedProductsMainSalesRank: [],
    buyBoxPrices: [],
    relatedProducts: [],
    relatedProductBuyBoxPrices: []

}
const mapStateToProps = (state) => ({
    mainSalesRank: mainSalesRankSelector(state),
    subSalesRank: subSalesRankSelector(state),
    relatedProductsMainSalesRank: relatedProductsMainSalesRankSelector(state),
    buyBoxPrices: buyBoxPricesSelector(state),
    relatedProducts: relatedProductsSelector(state),
    relatedProductBuyBoxPrices: relatedProductBuyBoxPricesSelector(state),
    shortcodeAsinPrices: shortcodeAsinPricesSelector(state)
})

const actionCreators = {
    fetchPricingListings,
    getSalesRank,
    getBuyBoxPrices,
    getRelatedProducts,
    addRelatedProduct,
    updateRelatedProducts,
    editRelatedProduct,
    clearSalesRankAndBuyBoxPrice,
    fetchShortcodeAsinPrices
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, PricingDashboardForm);